module.exports = "/packs/chevron-left-gray-ac4a0886e278bf992fa22f9859b459c5.svg";